import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import "./Modal.css";

const Modal = ({
  children,
  onClose,
  show,
  title,
  position = "center",
  width = "100%",
  isLastModal = false,
  showModalOnLoad = false,
  isEcomm = false,
  overflow = "hidden",
}) => {
  const nodeRef = useRef(null);

  const closeOnEscapeKeyDown = (e) => {
    if ((e.charCode || e.keyCode) === 27) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);

  if (showModalOnLoad) {
    return ReactDOM.createPortal(
      <div
        style={{
          position: "fixed",
          height: "100%",
          width: "100%",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="z-13"
        ref={nodeRef}
        onClick={onClose}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            maxWidth: "600px",
          }}
        >
          <div
            className={`modal-content bottom-0 rounded-t-[16px]  bottom overflow-x-hidden`}
            style={{
              width: width,
              backgroundColor: "#fff",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-body" style={{ borderColor: "#fff" }}>
              {children}
            </div>
          </div>
        </div>
      </div>,
      document.getElementById("modal-root")
    );
  }

  return ReactDOM.createPortal(
    <CSSTransition
      in={show}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{
        enter: 100,
        exit: 500,
      }}
    >
      <div
        className={`modal ${isEcomm ? "z-30" : "z-13"} `}
        ref={nodeRef}
        onClick={onClose}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            maxWidth: "600px",
          }}
        >
          <div
            className={`modal-content modal-content--${position} `}
            style={{
              width: width,
              backgroundColor: isLastModal ? "#6C63FF" : "#fff",
              overflow: overflow,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="modal-body"
              style={{ borderColor: isLastModal ? "#6C63FF" : "#fff" }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById("modal-root")
  );
};

export default Modal;
